<!--
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="comp-item">
    <component :is="type" :comp-index="index" :value="value" :ispreview="true" @change="timeChange" ref="component" class="comp-child"/>
    <div class="btn-export" v-if="isExport" :style="{
      left: position.left+position.width + 'px',
      top: position.top + 1 + 'px',
      height: position.height + 'px'
    }">
      <a-button @click="exportClick" v-if="typeMap[type]" size="small" type="primary" ghost> 
        <icon-font class="title-icon" type="icon-Export"  />
          导出
      </a-button>
    </div>
  </div>
</template>

<script>
import widgetHref from "./widgetHref.vue";
import widgetCard from "./widgetCard.vue";
import widgetText from "./widgetText.vue";
import widgetButton from "./widgetButton.vue";
import widgetTextFilter from "./widgetTextFilter.vue";
import WidgetMarquee from "./widgetMarquee.vue";
import widgetTime from "./widgetTime.vue";
import widgetFilter from "./widgetFilter.vue";
import widgetImage from "./widgetImage.vue";
import widgetSlider from "./widgetSlider.vue";
import widgetVideo from "./widgetVideo.vue";
import WidgetIframe from "./widgetIframe.vue";
import widgetBarchart from "./bar/widgetBarchart.vue";
import widgetLinechart from "./line/widgetLinechart.vue";
import widgetBarlinechart from "./bar/widgetBarlinechart";
import widgetGradientColorBarchart from "./bar/widgetGradientColorBarchart.vue";
import WidgetPiechart from "./pie/widgetPiechart.vue";
import WidgetFunnel from "./widgetFunnel.vue";
import WidgetGauge from "./percent/widgetGauge.vue";
import WidgetPieNightingaleRoseArea from "./pie/widgetPieNightingaleRose";
import widgetTable from "./table/widgetTable.vue";
import widgetMap from "./widgetMap.vue";
import widgetPiePercentageChart from "./percent/widgetPiePercentageChart";
import widgetAirBubbleMap from "./map/widgetAirBubbleMap";
import widgetBarStackChart from "./bar/widgetBarStackChart";
import widgetLineStackChart from "./line/widgetLineStackChart";
import widgetBarCompareChart from "./bar/widgetBarCompareChart";
import widgetLineCompareChart from "./line/widgetLineCompareChart";
import widgetDecoratePieChart from "./decorate/widgetDecoratePieChart";
import widgetMoreBarLineChart from "./bar/widgetMoreBarLineChart";
// import widgetWordCloud from "./wordcloud/widgetWordCloud";
import html2canvas from 'html2canvas'
import { templateExport } from '@/api/template'

export default {
  name: "WidgetTemp",
  components: {
    widgetHref,
    widgetCard,
    widgetText,
    WidgetMarquee,
    widgetTime,
    widgetButton,
    widgetTextFilter,
    widgetFilter,
    widgetImage,
    widgetSlider,
    widgetVideo,
    WidgetIframe,
    widgetBarchart,
    widgetGradientColorBarchart,
    widgetLinechart,
    widgetBarlinechart,
    WidgetPiechart,
    WidgetFunnel,
    WidgetGauge,
    WidgetPieNightingaleRoseArea,
    widgetTable,
    widgetMap,
    widgetPiePercentageChart,
    widgetAirBubbleMap,
    widgetBarStackChart,
    widgetLineStackChart,
    widgetBarCompareChart,
    widgetLineCompareChart,
    widgetDecoratePieChart,
    widgetMoreBarLineChart,
    // widgetWordCloud
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    type: String,
    value: {
      type: [Object],
      default: () => {
      }
    },
    name: String,
    dashboard: {
      type: [Object],
      default: () => {
      }
    },
    widget: {
      type: [Object],
      default: () => {
      }
    },
    isExport: Boolean,
    index: Number,
    searchCondition: {
      type: [Array],
      default: () => []
    },
  },
  data() {
    return {
      position: {
        left: 0,
        top: 0,
        width: 0,
        height: 30
      },
      typeMap: {
        'widget-card': '数字卡片',
        'widget-table': '表格',
        'widget-linechart': '折线图',
        'widget-piechart': '饼状图',
        'widget-barchart': '柱状图',
        'widget-barlinechart': '柱状折线图',
        'widget-funnel': '漏斗图',
      },
    };
  },
  mounted() {
    console.log(this.value, this.typeMap[this.type])
    this.position = this.value.position
  },
  methods: {
    exportClick() {
      let canvasID = this.$refs['component']
      canvasID = canvasID.$el || canvasID
      this.$store.commit("modelDesign/SET_VIEW_LOADING", true);
      html2canvas(canvasID).then(async (canvas) => {
        let dom = document.body.appendChild(canvas)
        dom.style.display = 'none'
        document.body.removeChild(dom)
        let blob = this.dataURLToBlob(dom.toDataURL('image/png'))
        URL.revokeObjectURL(blob)
        let widgets = JSON.parse(JSON.stringify([this.widget]));
        let globalOptions;
        if (this.dashboard?.dynamicData?.contextData) {
          globalOptions = {
            globalAccountIds: this.dashboard.dynamicData.contextData.accountIds,
            globalDataSource: this.dashboard.dynamicData.contextData.datasource,
            globalFilterType: this.dashboard.dynamicData.contextData.filterType,
            globalTableId: this.dashboard.dynamicData.contextData.tableId,
          }
        }
        if(this.searchCondition.length) {
          if(globalOptions) {
            globalOptions.globalConditions = this.searchCondition
          } else {
            globalOptions = {
              globalConditions: this.searchCondition
            }
          }
        }
        widgets = widgets.filter(v => v.value?.data?.dataType === "dynamicData").map((v,i) => ({ 
          dynamicDataParam: { 
            ...v.value.data?.dynamicData || {},
            ...v.value.data?.dynamicData?.contextData?v.value.data.dynamicData.contextData:{},
            globalOptions
          },
          type: v.type,
          title: v.value.setup?.titleText || ''
        }))
        let index = 1
        widgets.filter(v => v.type === 'widget-table').forEach(v => {
          let title = v.title.replace(/\\|\/|\?|\?|\*|\[|\]|\[|\]|\:/g, '')
          if(!title) {
            title = `表格${index}`
            index++
          }
          v.title = title.slice(0, 31)
        })
        console.log(widgets)
        let param = new FormData()       // 创建form对象     
        param.append('file', blob)       // 通过append向form对象添加数据
        param.append("template", JSON.stringify({
          name: `${this.name}-${this.value?.setup?.titleText || this.typeMap[this.type]}`,
          widgets
        })); // 添加form表单中其他数据
        const res = await templateExport(param)
        if(res.code === 200) {
          this.$message.success('数据导出中，请稍后在【下载中心】查看')
        }
        this.$store.commit("modelDesign/SET_VIEW_LOADING", false);
      })
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while(n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr, {type: mime}])
    },
    timeChange(val) {
      console.log(val)
      this.$emit('timeChange', val)
    },
    init(data) {
      this.$refs.component.previewInit(data)
    },
    filterSearch() {
      try {
        this.$refs.component.filterSearch()
      } catch (error) {
        console.log(error)        
      }
    }
  }
};
</script>
<style scoped lang="less">
  .btn-export {
    display: none;
    position: absolute;
    background: transparent;
    z-index: 100;
    .ant-btn {
      background: transparent;
    }
    &:hover {
      display: block;
    }
  }
  .comp-child:hover + .btn-export {
    display: block;
  }
</style>
<style lang="less">
.workbench-dark {
  .comp-item {
    .btn-export {
      .ant-btn {
        color: #FFFFFF;
      }
    }
  }
}
</style>